/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YearWeek } from './YearWeek';
import type { User } from './User';
/**
 * 
 * @export
 * @interface UserGoal
 */
export interface UserGoal {
    /**
     * 
     * @type {number}
     * @memberof UserGoal
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserGoal
     */
    yearWeek?: number;
    /**
     * 
     * @type {number}
     * @memberof UserGoal
     */
    value?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserGoal
     */
    achieved?: boolean;
    /**
     * 
     * @type {User}
     * @memberof UserGoal
     */
    user?: User;
    /**
     * 
     * @type {YearWeek}
     * @memberof UserGoal
     */
    yearWeekNavigation?: YearWeek;
}

/**
 * Check if a given object implements the UserGoal interface.
 */
export function instanceOfUserGoal(value: object): value is UserGoal {
    return true;
}

export function UserGoalFromJSON(json: any): UserGoal {
    return UserGoalFromJSONTyped(json, false);
}

export function UserGoalFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGoal {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'yearWeek': json['yearWeek'] == null ? undefined : json['yearWeek'],
        'value': json['value'] == null ? undefined : json['value'],
        'achieved': json['achieved'] == null ? undefined : json['achieved'],
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
        'yearWeekNavigation': json['yearWeekNavigation'] == null ? undefined : (require('./YearWeek') as typeof import('./YearWeek')).YearWeekFromJSON(json['yearWeekNavigation']),
    };
}

export function UserGoalToJSON(json: any): UserGoal {
    return UserGoalToJSONTyped(json, false);
}

export function UserGoalToJSONTyped(value?: UserGoal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'yearWeek': value['yearWeek'],
        'value': value['value'],
        'achieved': value['achieved'],
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
        'yearWeekNavigation': (require('./YearWeek') as typeof import('./YearWeek')).YearWeekToJSON(value['yearWeekNavigation']),
    };
}

